import { FilterOperator } from 'src/app/models/ui/filter';
import { DataType, isBooleanType, isDateType, isNumberType, isTextType } from '../../models/ui/datatype';

export const isEqualOperator: FilterOperator = {
  name: '=',
  value: 'isEqual',
};

export const isNotEqualOperator: FilterOperator = {
  name: '<>',
  value: 'isNotEqual',
};

export const isEmptyOperator: FilterOperator = {
  name: '= Ø',
  value: 'isEmpty',
};

export const isNotEmptyOperator: FilterOperator = {
  name: '<> Ø',
  value: 'isNotEmpty',
};

export const containsOperator: FilterOperator = {
  name: '...xxx...',
  value: 'contains',
};

export const startsWithOperator: FilterOperator = {
  name: 'xxx...',
  value: 'startsWith',
};

export const endsWithOperator: FilterOperator = {
  name: '...xxx',
  value: 'endsWith',
};

export const isLessThanOperator: FilterOperator = {
  name: '<',
  value: 'isLessThan',
};

export const isLessThanOrEqualOperator: FilterOperator = {
  name: '<=',
  value: 'isLessThanOrEqual',
};

export const isGreaterThanOperator: FilterOperator = {
  name: '>',
  value: 'isGreaterThan',
};

export const isGreaterThanOrEqualOperator: FilterOperator = {
  name: '>=',
  value: 'isGreaterThanOrEqual',
};

export const betweenOperator: FilterOperator = {
  name: 'xxx...xxx',
  value: 'between',
};

export const noneOperator = {
  name: '- (None)',
  value: 'none',
};

export const commonOperators: FilterOperator[] = [
  isEqualOperator,
  isNotEqualOperator,
  isEmptyOperator,
  isNotEmptyOperator,
];

export const textOperators: FilterOperator[] = [containsOperator, startsWithOperator, endsWithOperator];

export const numericOperators: FilterOperator[] = [
  isLessThanOperator,
  isLessThanOrEqualOperator,
  isGreaterThanOperator,
  isGreaterThanOrEqualOperator,
  betweenOperator,
];

export class OperatorFactory {
  getOperators(dataType: DataType): FilterOperator[] {
    let operators = [];
    if (isNumberType(dataType)) {
      operators = commonOperators.concat(numericOperators);
    } else if (isTextType(dataType)) {
      operators = textOperators.concat(commonOperators);
    } else if (isDateType(dataType)) {
      operators = numericOperators.concat(commonOperators);
    } else if (isBooleanType(dataType)) {
      operators = [isEqualOperator, isNotEqualOperator, isEmptyOperator, isNotEmptyOperator];
    } else {
      console.warn(`Cannot find specific operators for data type ${dataType}`);
      operators = commonOperators;
    }
    return operators;
  }
}
